import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

export const fileStore = defineStore({
  id: 'file',
  state: () => ({
    files: [],
    file: null
  }),
  actions: {
    async getFiles(firm) {
      this.files = []
      let response = await api.get(`data/files?firm=${firm}`)
      if (response) {
        if (response !== '') {
          this.files = response
        }
      }
    },
    async getFile(url) {
      let response = await api.get(url)
      return response
    },
    async deleteFile(data) {
      let filename = data.filename.replace(data.folder + '/', '')
      await api.delete(`data/removeFile?folder=${data.folder}&filename=${encodeURIComponent(filename)}&id=${data.id}`)
    },
    async updateFileInfo(data) {
      await api.post('data/updateFileInfo', data)
    }
  }
})
